define('webshopLandingpagesDetailBodyLandingpageBodyView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'selectView',
  'checkboxView',
  'modalsConfirmationView',
  'webshopCommonRedirectionView',
  'webshopLandingpagesDetailBodyLandingpageBodyIndexesView',
  'webshopCategorySelectView',
  'template!webshopLandingpagesDetailBodyLandingpageBodyView',
  'entities/webshop/landingpages'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  SelectView,
  CheckboxView,
  ConfirmationView,
  RedirectionView,
  IndexesView,
  CategorySelectView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-landingpages-detail-body-Landingpage-body-view',

    ui: {
      code: '.landingpage-code input',
      category: '.category'
    },

    modelEvents: {
      'change:code': 'renderCode',
      'change:domain': 'renderDomain', 
      'change:template': 'renderTemplate'
    },

    events: {
      'change @ui.code': 'onChangeCode'
    },

    regions: {
      indexesRegion: '.indexes-region',     
      categorySelectRegion: '.category-select-region',
      domainRegion: '.domain-region',
      templateRegion: '.template-region'
    },

    initialize: function () {
      this.templatesCollection = new Backbone.Collection();
    },

    onRender: function () {
      this.domainView = new SelectView({
        collection: new Backbone.Collection([
          {id: 'category',  value: _.i18n('common.category')},
          {id: 'product',  value: _.i18n('common.product')},
          {id: 'global', value: _.i18n('common.global')}
        ])
      });
      this.domainRegion.show(this.domainView);
      this.domainView.on('change', _.bind(this.onDomainChange, this));

      //--------------------
      this.templateView = new SelectView({
        collection: this.templatesCollection
      });
      this.templateRegion.show(this.templateView);
      this.templateView.on('change', _.bind(this.onTemplateChange, this));
      this.fetchTemplates();     

      //--------------------      
      this.indexesView = new IndexesView({
        model: this.model,
        webshopConfig: this.options.webshopConfig
      });
      this.indexesRegion.show(this.indexesView);      

      //--------------------
      this.categorySelectView = new CategorySelectView({
        model: new Backbone.Model({
          id: this.model.get('categoryId'),
          code: this.model.get('categoryCode')          
        }),
        onChange: _.bind(function (model) {
          var defer = $.Deferred();
          this.model.setParentId(model.get('id')).done(_.bind(function () {
            this.model.fetch();
            defer.resolve();
          }, this));            
          return defer.promise();
        }, this)       
      });      
      this.getRegion('categorySelectRegion').show(this.categorySelectView);
    
      //--------------------
      this.renderCode();
      this.renderDomain();      
      this.fetchTemplates();
    },

    renderCode: function () {
      this.ui.code.val(this.model.getCode());
    },

    renderDomain: function () {
      this.domainView.setValue(this.model.getDomain());
    },

    fetchTemplates: function () {
      this.templatesCollection.reset();
      $.ajax({
        type: 'GET',
        url:  Settings.url('compuzz2', 'webshop/landingpages/templates', {domain: this.model.getDomain()}),
        success: _.bind(function (templates) {          
          _.each(templates, function (template) {
            this.templatesCollection.add({
              id: template.id,
              value: template.id
            });
          }, this);

          this.renderTemplate();
        }, this)
      });
    },

    renderTemplate: function () {           
      if (this.templateView)
        this.templateView.setValue(this.model.getTemplate());
    },

    onChangeCode: function () {
      this.model.setCode(this.ui.code.val()).always(_.bind(function () {
        this.model.fetch();
      }, this));
    },

    onDomainChange: function () {
      var domain = this.domainView.getValue();
      this.model.setDomain(domain).done(_.bind(function () {
        this.model.fetch().done(_.bind(function () {
          this.fetchTemplates();
        }, this));
      }, this));
    },

    onTemplateChange: function () {
      var template = this.templateView.getValue();
      this.model.setTemplate(template).done(_.bind(function () {
        this.model.fetch();
      }, this));
    }
  });
});
